import Flag from 'components/Flag/Flag';
import * as React from 'react';
import { OptionProps } from 'react-select/lib/components/Option';
import styled from 'styled-components';

export const FlagOption: React.SFC<
  OptionProps<{ label: string; value: string }>
> = props => {
  return (
    <Container {...props.innerProps}>
      <FlagContainer>
        {props.data.value !== 'global' && (
          <Flag size={32} code={props.data.value} />
        )}
      </FlagContainer>
      <Text>{props.data.label}</Text>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  &:hover {
    background: #eee;
  }
`;

const Text = styled.div`
  flex: 1;
  margin-left: 15px;
`;

const FlagContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-left: 15px;
`;

export default FlagOption;



// WEBPACK FOOTER //
// ./src/components/FlagOption/FlagOption.tsx